import { useUserScopes } from "#/services/dynamic/hooks/useUserScopes";
import { useNettedOptionUserPortfolio } from "#/services/kyan/hooks/useNettedUserPortfolio";
import { useIsDevMode } from "#/store/app/devMode/devMode";
import { useMarket } from "#/store/app/portfolio/market";
import { useOption } from "#/store/options/tradePanel/option";
import { UnderlyingSymbol } from "#/types/markets";
import { RiskPosition } from "#/types/positions";
import { validateOptionSize } from "#/utils/validateOptionSize";

import { useValidateMaxNumOfOrders } from "./useValidateMaxNumOfOrders";

interface UseValidateOptionSizeParams {
  size: string;
  underlying: UnderlyingSymbol;
  isLimit?: boolean;
  isRfq?: boolean;
  isShortError?: boolean;
}

export const useValidateOptionSize = ({
  size,
  underlying,
  isLimit = false,
  isRfq,
  isShortError,
}: UseValidateOptionSizeParams) => {
  const { hasEarlyAccessVip } = useUserScopes();
  const { isDevMode } = useIsDevMode();
  const { option } = useOption();
  const { market } = useMarket();
  const hasNoGuardRails = isDevMode || hasEarlyAccessVip;
  const nettedPositions = useNettedOptionUserPortfolio({
    option,
    market,
    inputs: [],
  }) as RiskPosition | undefined;
  const maxNumOfOrdersError = useValidateMaxNumOfOrders(
    underlying,
    size,
    isLimit,
  );

  if (maxNumOfOrdersError && !hasNoGuardRails) return maxNumOfOrdersError;

  const isBuy = option?.isBuy ?? true;

  const sizeError = validateOptionSize({
    size,
    underlying,
    isRfq,
    isBuy,
    isShortError,
    nettedPositions: nettedPositions?.size ?? 0,
    hasNoGuardRails,
  });

  return sizeError;
};
